import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as formActions from "../../../store/actions/forms";
import styles from "./AutoGlassForm.module.css";
import { autoGlassReport, baseTitle } from "../../../constants/messages";
import Input from "../../shared/ui/input/Input";

function AutoGlassForm() {
  const dispatch = useDispatch();
  let autoPolicies = useSelector((state) => state.forms.autoPolicies);
  let activePolicy = useSelector((state) => state.policies.activePolicy);
  let policySelectOptions;

  const handlePolicyChange = (policyNumber) => {
    dispatch(formActions.sendAutoGlassForm(policyNumber));
  };

  // If agent selected policy display only one policy option, otherwise all the policies for an insured
  if (activePolicy) {
    autoPolicies = [
      {
        policyNumber: activePolicy.PolicyNumber,
        policyEffectiveDate: activePolicy.PolicyEffectiveDate,
        policyType: activePolicy.PolicyType,
      },
    ];
    policySelectOptions = (
      <option
        key={autoPolicies[0].policyNumber}
        value={`${autoPolicies[0].policyNumber}/${autoPolicies[0].policyEffectiveDate}`}
        selected="selected"
      >
        {`${autoPolicies[0].policyNumber} - ${autoPolicies[0].policyType}`}
      </option>
    );
  } else {
    policySelectOptions = autoPolicies.map((policy) => {
      return (
        <option
          key={policy.policyNumber}
          value={`${policy.policyNumber}/${policy.policyEffectiveDate}`}
        >
          {`${policy.policyNumber} - ${policy.policyType}`}
        </option>
      );
    });

    policySelectOptions = [
      <option key={"select"} value="select">
        Select a Policy
      </option>,
      ...policySelectOptions,
    ];
  }

  useEffect(() => {}, [dispatch, activePolicy]);

  useEffect(() => {
    document.title = baseTitle + " - Report Auto Glass Claim";
  }, []);

  return (
    <div className={styles.container}>
      <p className={styles.autoGlassText}>{autoGlassReport}</p>
      <div className={`formRow ${styles.formRow}`}>
        <Input label="" width="33%">
          <select
            name="policy"
            id="Policy"
            onChange={(e) => handlePolicyChange(e.target.value)}
          >
            {policySelectOptions}
          </select>
        </Input>
      </div>
    </div>
  );
}

export default AutoGlassForm;
